import React from 'react';
import { StyledPost, StyledBlogList } from './StyledBlog';
import { FlatButton } from '../button/Button';
import Seperator from "../seperator";
import { GatsbyImage } from "gatsby-plugin-image";


const BlogList = ({ data }) => {
    const { edges: posts } = data.allMarkdownRemark;

    return (
        <StyledBlogList>
            {posts.map(post => (
                <>
                    <Seperator />
                    <Post post={post} />
                </>
            ))}
        </StyledBlogList>
    )
};

const ImgStyle = {
    width: '300px',
    imgStyle: 'fixed',
    objectFit: 'cover',
    height: '300px',
    display: 'block',
}

const Post = ({ post }) => (
    <StyledPost to={post.node.fields.slug}>
        <div>
            <h2>{post.node.frontmatter.title}</h2>
            <p>{post.node.frontmatter.description}</p>
            <FlatButton to={post.node.fields.slug}>Read this</FlatButton>
        </div>
        <GatsbyImage style={ImgStyle} imgStyle={ImgStyle} objectFit={"cover"} image={post.node.frontmatter.image.childImageSharp.gatsbyImageData} alt='image' />
    </StyledPost>
);

export default BlogList;
